exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".module-app .home-header[data-v-bc232558]{position:relative}.module-app .home-header .btn[data-v-bc232558]{position:absolute;left:.53333rem;bottom:4.85333rem;width:4rem;background:transparent;border:none}", "", {"version":3,"sources":["/Users/randy/kada-official-web/public/mobile/src/views/home/QRAndBg.vue"],"names":[],"mappings":"AACA,0CACE,iBAAmB,CACpB,AACD,+CACE,kBAAmB,AACnB,eAAiB,AACjB,kBAAmB,AACnB,WAAY,AACZ,uBAAwB,AACxB,WAAa,CACd","file":"QRAndBg.vue","sourcesContent":["\n.module-app .home-header[data-v-bc232558] {\n  position: relative;\n}\n.module-app .home-header .btn[data-v-bc232558] {\n  position: absolute;\n  left: 0.53333rem;\n  bottom: 4.85333rem;\n  width: 4rem;\n  background: transparent;\n  border: none;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bc232558","scoped":true,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/home/QRAndBg.vue
// module id = 7DzZ
// module chunks = 0 1